import { setSelectLanguage, setSelectCurrency } from '@/store/locale';
export interface LanguageObj {
	code: string;
	desc: string;
	icon: string;
}
export interface LoginForm {
	username: string;
	usernameError: boolean;
	password: string;
	passwordError: boolean;
	isSelectProtocol: boolean;
	isSelectProtocolError: boolean;
}
export interface LanguageObjCode {
	[key: string]: {
		desc: string;
		icon: string;
	};
}

export interface LoginSusDataLo {
	gender: string;
	token: string;
	userId: string;
	uname: string;
}
export interface LanguageInfo {
	selectLanguage: string;
	languageList: LanguageObj[];
	languageObjList: LanguageObjCode;
}

export interface RegisterForm {
	email: string;
	password: string;
}
// 联系我们
export interface ContactUsLo {
	userName: string;
	userNameError?: boolean;
	companyName: string;
	companyNameError?: boolean;
	email: string;
	emailError?: boolean;
	phone: string;
	phoneError?: boolean;
	subject: string;
	subjectError?: boolean;
	message: string;
	messageError?: boolean;
}
export class NewContactUsLoInfo {
	userName: string = '';
	companyName: string = '';
	email: string = '';
	phone: string = '';
	subject: string = '';
	message: string = '';
}
export class NewContactUsLoInfoError extends NewContactUsLoInfo {
	userNameError: boolean = false;
	companyNameError: boolean = false;
	emailError: boolean = false;
	phoneError: boolean = false;
	subjectError: boolean = false;
	messageError: boolean = false;
}
export interface CurrencyListObj {
	code: '';
	domain: '';
}
export class CurrencyInfo {
	selectCurrency: string = '';
	currencyList: CurrencyListObj[] = [
		{
			code: '',
			domain: ''
		}
	];
	constructor () {
	}
}
export class HeaderCurrencyInfo extends CurrencyInfo {
	constructor () {
		super();
	}
	changeSelectCurrency(currency: string) {
		setSelectCurrency(currency);
		this.selectCurrency = currency;
	}
};

export class NewLanguageInfo {
	selectLanguage: string = '';
	languageList: LanguageObj[] = [
		{
			code: '',
			desc: '',
			icon: ''
		}];
	languageObjList: LanguageObjCode = {};
	constructor () {
	}
}
export class HeaderNewLanguageInfo extends NewLanguageInfo {
	constructor () {
		super();
	}
	changeSelectLanguage(language: string) {
		setSelectLanguage(language);
		this.selectLanguage = language;
	}
}
export class NewHeader {
	isShowLanguage: boolean = false;//是否展示语言
	isShowCurrency: boolean = false; //是否展示币种
	isShowLogin: boolean = false; //是否登录
	isShowRegister: boolean = false; //是否注册
	loginUserName: string = '';  //用户名
	topDistance: number = 0;  //滚动距离顶部距离
	pathName: string = '';  //路由名称
	isShowPersonCenter: boolean = false;
	constructor () {

	}
	setLanguageRef(isShowLanguage: boolean) {
		this.isShowLanguage = isShowLanguage;
	}
	setCurrencyRef(isShowCurrency: boolean) {
		this.isShowCurrency = isShowCurrency;
	}
	setShowPersonCenter(isShowPersonCenter: boolean) {
		this.isShowPersonCenter = isShowPersonCenter;
	}
	setLoginUserName(loginUserName: string) {
		this.loginUserName = loginUserName;
	}
	setTopDistance(distance: number) {
		this.topDistance = distance;
	}
}
export class NewLoginForm {
	username: string = "";
	password: string = "";
	constructor () {
	}
}
export class HeaderNewLoginForm extends NewLoginForm {
	usernameError: boolean = false;
	passwordError: boolean = false;
	isSelectProtocol: boolean = true;
	isSelectProtocolError: boolean = false;
	constructor () {
		super();
	}
}
export class NewRegisterForm {
	email: string = '';
	password: string = '';
	verifyPassword: string = '';
	constructor () {
	}
};
export class HeaderNewRegisterForm extends NewRegisterForm {
	emailError: boolean = false;
	passwordError: boolean = false;
	verifyPasswordError: boolean = false;
	constructor () {
		super();
	}
};
export class NewMemberLoginData {
	gender: string = '';
	token: string = '';
	userId: string = '';
	uname: string = '';
	email: string = '';
	constructor () {
	}
}

export class NewHeaderLoginRef {
	hostUrl: string = window.location.host;
	isViews: boolean = false;
	passwordType: string = 'password';
	constructor () {
	}
}
export class NewHeaderRegisterRef {
	isPasswordViews: boolean = false;
	passwordType: string = 'password';
	verifyPasswordType: string = 'password';
	isVerifyPasswordViews: boolean = false;
	constructor () {
	}
}
